import { createDomain } from 'effector'

const domain = createDomain('bonus banner domain')

export const closeBanner = domain.createEvent('close bonus banner')

export const $isBonusBannerShown = domain
  .createStore(true)
  .on(closeBanner, () => false)
